import {memo, useContext} from 'react'

import PropTypes from 'prop-types'

import AtomButton, {atomButtonSizes} from '@s-ui/react-atom-button'
import Context from '@s-ui/react-context'
import {useMediaQuery, useMediaQueryBreakpoints} from '@adv-mt/mt-layout-render-media-query'
import IconArrowDownUp from '@adv-mt/mt-svg-icons/lib/ArrowDownUp'
import IconChevronDown from '@adv-mt/mt-svg-icons/lib/ChevronDown'
import IconSort from '@adv-mt/mt-svg-icons/lib/Sort'

import {BUTTON_PROPS as searchSortButtonProps, DESIGNS as searchSortButtonDesigns, ELEMENT_IDS} from './config.js'
import SearchSortManagementInfo from './sortManagementInfo.js'

const SearchSortButton = ({design = searchSortButtonDesigns.BASIC, label, linkFactory, onClick, withSortOrderInfo}) => {
  const {domain, i18n} = useContext(Context)

  const config = domain.get('config')

  const isMobile = config.get('isMobile')

  const isMobileOrWider = useMediaQuery(useMediaQueryBreakpoints.xs, {
    defaultMatches: !isMobile
  })

  const designButtonProps = searchSortButtonProps[design]

  const isHighlightedDesign = design === searchSortButtonDesigns.HIGHLIGHTED
  const isCompressedDesign = design === searchSortButtonDesigns.COMPRESSED

  const rightIcon = <IconChevronDown aria-hidden role="presentation" />

  const SortIcon = isCompressedDesign ? IconArrowDownUp : IconSort

  const leftIcon =
    (!isMobileOrWider && isHighlightedDesign) || isCompressedDesign ? (
      <SortIcon aria-hidden role="presentation" size={designButtonProps.iconSize} />
    ) : null

  return (
    <div className="mt-SearchSort-button">
      {withSortOrderInfo && <SearchSortManagementInfo linkFactory={linkFactory} />}
      {!isCompressedDesign && (
        <p className="mt-SearchSort-buttonFieldLabel" id={ELEMENT_IDS.BUTTON_PREFIX}>
          {i18n.t('COMMON_SORT')}:
        </p>
      )}
      <AtomButton
        aria-haspopup="dialog"
        aria-labelledby={`${ELEMENT_IDS.BUTTON_PREFIX} ${ELEMENT_IDS.BUTTON_LABEL}`}
        id={ELEMENT_IDS.BUTTON_LABEL}
        leftIcon={leftIcon}
        onClick={onClick}
        rightIcon={!isCompressedDesign ? rightIcon : null}
        title={label}
        {...designButtonProps}
        {...(!isCompressedDesign && {size: !isMobileOrWider ? atomButtonSizes.SMALL : atomButtonSizes.LARGE})}
      >
        {!isCompressedDesign && label}
      </AtomButton>
    </div>
  )
}

SearchSortButton.displayName = 'SearchSortButton'
SearchSortButton.propTypes = {
  design: PropTypes.oneOf(Object.keys(searchSortButtonDesigns)),
  hasLeftIcon: PropTypes.bool,
  isWebMobileFiltersAccessSortOrderVariation: PropTypes.bool,
  label: PropTypes.string.isRequired,
  linkFactory: PropTypes.func,
  onClick: PropTypes.func.isRequired,
  withSortOrderInfo: PropTypes.bool
}

export {searchSortButtonDesigns}

export default memo(SearchSortButton)
